<template>
  <div>
    <div class="order-list" v-if="dataPermission && dataPermission.includes('NSH_PARTNER_CUS_VIEW')">
      <div class="title-header-77 mb-3">Danh sách đơn hàng</div>
      <b-card class="form-card mb-0">
        <div class="order-list_body">
          <div class="order-list-nav order-list-header d-flex justify-content-between align-items-center">
            <div class="order-list_header d-flex">
              <el-popover placement="bottom-start" width="530" trigger="click" v-model="showFilter">
                <!-- btn -->
                <el-button class="n-btn mr-2" slot="reference" type="info">
                  <div class="n-icon">
                    <i class="mdi mdi-filter-outline"></i>
                    Bộ lọc
                  </div>
                </el-button>
                <!-- slot -->
                <div class="row d-flex align-items-center mb-3">
                  <div class="col-3 text-right">Thời gian tạo:</div>
                  <div class="col-9">
                    <el-date-picker popper-class="custom-picked" class="w-100" type="daterange" align="right" start-placeholder="Từ ngày" end-placeholder="Đến ngày" format="dd/MM/yyyy" v-model="createdAtRange" :picker-options="pickerOptions"> </el-date-picker>
                  </div>
                </div>

                <div class="row d-flex align-items-center mb-3">
                  <div class="col-3 text-right">Cập nhật:</div>
                  <div class="col-9">
                    <el-date-picker popper-class="custom-picked" class="w-100" type="daterange" align="right" start-placeholder="Từ ngày" end-placeholder="Đến ngày" format="dd/MM/yyyy" v-model="updatedAtRange" :picker-options="pickerOptions"> </el-date-picker>
                  </div>
                </div>

                <div class="row d-flex align-items-center mb-3">
                  <div class="col-3 text-right">Thiết bị:</div>
                  <div class="col-9">
                    <el-select class="w-100" v-model="saleChannel" placeholder="Tất cả">
                      <el-option v-for="item in optionsSaleChannel" :key="item.value" :label="item.text" :value="item.value"> </el-option>
                    </el-select>
                  </div>
                </div>

                <div class="row d-flex align-items-center mb-3">
                  <div class="col-3 text-right">Trạng thái đơn:</div>
                  <div class="col-9">
                    <el-select class="w-100" v-model="status" placeholder="Tất cả">
                      <el-option v-for="item in statusOptions" :key="item.value" :label="item.text" :value="item.value"> </el-option>
                    </el-select>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 d-flex justify-content-end">
                    <el-button class="n-btn" @click="showFilter = false">Hủy</el-button>
                    <el-button class="n-btn" type="danger" plain @click="resetFilter">Xóa bộ lọc</el-button>
                    <el-button class="n-btn" type="primary" @click="searchItem">Áp dụng bộ lọc</el-button>
                  </div>
                </div>
                
              </el-popover>
              <el-input style="width: 280px" placeholder="Tìm kiếm" v-model="search.textSearch" @keydown.enter.native="searchItem" clearable>
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
              
            </div>
            <div class="d-flex">
              <el-button class="n-btn mx-2" v-if="downloadStorage && downloadStorage.linkDownload != ''" @click="clickCheckLinkDowload" type="info">
                <div class="n-icon">
                  <i v-if="!isLoadLinkDownload" class="mdi mdi-export"></i>
                  <i v-else class="mdi mdi-loading mdi-spin"></i>
                  Tải dữ liệu
                </div>
              </el-button>
              <el-button class="n-btn mx-2" v-else :disabled="isLoadLinkDownload"  @click="clickExportData" type="info">
                <div class="n-icon">
                  <i v-if="!isLoadLinkDownload" class="mdi mdi-export"></i>
                  <i v-else class="mdi mdi-loading mdi-spin"></i>
                  Xuất dữ liệu
                </div>
              </el-button>
              <!-- export theo chi tiet don -->
              <el-button class="n-btn mx-2" v-if="downloadStorage2 && downloadStorage2.linkDownload != ''" @click="clickCheckLinkDowload2" type="info">
                <div class="n-icon">
                  <i v-if="!isLoadLinkDownload2" class="mdi mdi-export"></i>
                  <i v-else class="mdi mdi-loading mdi-spin"></i>
                  Tải chi tiết đơn
                </div>
              </el-button>
              <el-button class="n-btn mx-2" v-else :disabled="isLoadLinkDownload2"  @click="clickExportData2" type="info">
                <div class="n-icon">
                  <i v-if="!isLoadLinkDownload2" class="mdi mdi-export"></i>
                  <i v-else class="mdi mdi-loading mdi-spin"></i>
                  Xuất chi tiết đơn
                </div>
              </el-button>
              <b-pagination @change="changeCurrentPage" v-model="currentPage" :total-rows="totalElements" :per-page="search.pageSize" aria-controls="debt-table" hide-goto-end-buttons limit="5" last-text="next" align="right" />
            </div>
          </div>
          <div class="order-list-table">
            <ItemArrangeColumn v-model="fields" />
            <b-table class="n-table" :items="dataItem" :fields="fields.filter(e => e.show)" :key="updateUI" show-empty @row-clicked="clickRowItem">
              <template #head(edit)>
                <img @click="showPopup('Cai-dat-hien-thi'), (visibleEditShow = true)" src="@/assets/images/icon/menu_option.svg" />
              </template>
              <template #cell(orderNo)="data">
                <div class="text-nowrap text-primary cursor">{{ data.item.orderNo }}</div>
              </template>
              <template #cell(targetMethod)="data">
                <div class="text-nowrap">{{ targetMethodName[data.item.targetMethod] }}</div>
              </template>
              <template #cell(total)="data">
                <div class="text-nowrap">{{ formatMoney(divisionThousand(data.item.total)) }}</div>
              </template>
              <template #cell(saleName)="data">
                <div>{{ data.item.partyA.displayName || '---' }}</div>
              </template>
              <template #cell(updatedAt)="data">
                <div>{{ timeFormatStatus(data.item.updatedAt) }}</div>
              </template>
              <template #cell(createdAt)="data">
                <div>{{ timeFormatStatus(data.item.createdAt) }}</div>
              </template>
              <template #cell(processorStatus)="data">
                <StatusBox class="m-auto" :status="data.item.processorStatus"></StatusBox>
              </template>
              <!-- <template #cell(deliveryStatus)="data">
                <StatusBox class="m-auto" :status="getDeliveryStatus(data.item.SO_ORDER_OPERATION && data.item.SO_ORDER_OPERATION.params && data.item.SO_ORDER_OPERATION.params.deliveryStatus, data.item).status" :showText="getDeliveryStatus(data.item.SO_ORDER_OPERATION && data.item.SO_ORDER_OPERATION.params && data.item.SO_ORDER_OPERATION.params.deliveryStatus, data.item).text"></StatusBox>
              </template> -->
              <template #cell(paymentStatus)="data">
                <StatusBox class="m-auto" :status="getPaymentsStatus(data.item.SO_ORDER_OPERATION && data.item.SO_ORDER_OPERATION.params && data.item.SO_ORDER_OPERATION.params.paymentStatus).status" :showText="getPaymentsStatus(data.item.SO_ORDER_OPERATION && data.item.SO_ORDER_OPERATION.params && data.item.SO_ORDER_OPERATION.params.paymentStatus).text"></StatusBox>
              </template>
              <template #cell(edit)="data" no-select-on-click>
                <IconEditRecord v-if="data.item.processorStatus != 'TIMEOUT' && data.item.processorStatus != 'CANCEL' && checkIsDeleteAble(data.item) && dataPermission && dataPermission.includes('NSH_ORDER_CANCEL')" @click.native.stop :options="optionSelect" @select="chooseOption($event, data.item)" />
              </template>
            </b-table>
          </div>
          <div class="order-list-nav order-list-footer d-flex justify-content-end">
            <b-pagination @change="changeCurrentPage" v-model="currentPage" :total-rows="totalElements" :per-page="search.pageSize" aria-controls="debt-table" hide-goto-end-buttons limit="5" last-text="next" align="right" />
          </div>
        </div>
      </b-card>

      <!-- popup -->
      <el-dialog custom-class="popup-pos-detail" title="Huỷ đơn hàng" width="600px" :visible.sync="showOrderCancel" :show-close="false">
        <div class="body text-center">
          <div class="image" style="height: 120px">
            <img src="@assets/order-icon/Discard-order.png" />
          </div>
          <div class="mt-3">Bạn có chắc chắn muốn hủy đơn hàng này không?</div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button class="btn-custom" @click="showOrderCancel = false">Quay lại</el-button>
          <el-button @click="confirmDeleteItem()" plain type="danger">Hủy đơn</el-button>
        </div>
      </el-dialog>

       <!-- popup đơn hoàn thành -->
      <el-dialog custom-class="popup-pos-detail" title="Huỷ đơn hàng" width="600px" :visible.sync="showOrderSuccessCancel" :show-close="false">
        <div class="body text-center">
          <div class="image" style="height: 120px">
            <img src="@assets/order-icon/Discard-order.png" />
          </div>
          <div class="mt-3">Bạn có chắc chắn muốn hủy đơn hàng <b>{{tempItem.id}}</b> ?</div>
          <div class="mt-3 text-center" style="word-break: normal;">Hệ thống sẽ tiến hành thực hiện đơn trả hàng và nhập lại kho <br> những sản phẩm trong đơn hàng.</div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button class="btn-custom" @click="showOrderSuccessCancel = false">Quay lại</el-button>
          <el-button @click="confirmDeleteItem()" plain type="danger">Hủy đơn</el-button>
        </div>
      </el-dialog>

      <el-dialog
        custom-class="popup-pos-detail"
        width="600px"
        title="Xác nhận huỷ giao & huỷ đơn hàng"
        :visible.sync="showPopupCancelAll"
      >
        <div class="text-center">
          <img src="@/assets/images/icon-discard-file.svg" alt="icon">
          <p class="mb-3">Đơn giao và đơn hàng sẽ bị huỷ</p>
        </div>
        <div class="cancel-info">
          <b-alert class="custom-alert w-100" variant="warning text-dark" show>Phí của đơn giao hàng bị huỷ vẫn sẽ được hệ thống <b>trừ vào doanh thu</b>.<br> Vui lòng xác nhận lại chi phí bạn mất.</b-alert>
          <div class="row align-items-center">
            <div class="col-5">Xác nhận chi phí huỷ giao hàng:</div>
            <div class="col-7">
              <input-money-vmodel class="form-control text-right" v-model="feeDLO"></input-money-vmodel>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="confirmCancelAll" type="primary">Xác nhận hủy</el-button>
        </span>
      </el-dialog>
      
      <el-dialog custom-class="popup-pos-detail" title="Xác nhận huỷ giao & huỷ đơn hàng" width="600px" :visible.sync="showOrderDloCancel" :show-close="false">
        <div class="body text-center">
          <div class="image" style="height: 120px">
            <img src="@assets/order-icon/Discard-order.png" />
          </div>
          <div class="mt-3">Bạn có chắc chắn muốn huỷ giao & huỷ đơn hàng.</div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button class="btn-custom" @click="showOrderDloCancel = false">Quay lại</el-button>
          <el-button @click="() => handleOrderDLOCancelAndDoNothing(DLOid)" plain type="danger">Hủy đơn</el-button>
        </div>
      </el-dialog>


    </div>

    <NotPermission v-else></NotPermission>

    <!-- loading -->
    <div class="box-loading" v-if="loading">
      <div class="loading">
        <i class="bx bx-loader-circle bx-spin bx-rotate-90 fz50"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { OrdersService } from "@/services/nextshop/orders.service";
import VueCookies from "vue-cookies";
import moment from "moment";
import Swal from "sweetalert2";
import _ from "lodash"
import ItemArrangeColumn from "@/pages/items/components/ItemArrangeColumn.vue";
import StatusBox from '@/components/status-box.vue';
import InputMoneyVmodel from '../orders-return/components/inputMoneyVmodel.vue';
// import { getDeliveryStatus } from "@/utils/mapping";
import exportExcel from "@/mixins/exportExcel/index.js"
import copyExport from "@/mixins/exportExcel/copyExport.js"





export default {
  components: {
    ItemArrangeColumn,
    StatusBox,
    InputMoneyVmodel
  },
  mixins: [
    exportExcel,
    copyExport
  ],
  data() {
    return {
      visibleEditShow: false,
      dataPermission: JSON.parse(localStorage.getItem("dataPermission")),
      locationId: VueCookies.get("LID"),
      updateUI: 1,
      dataItem: [],
      loading: false,
      showOrderCancel: false,
      showOrderSuccessCancel: false,
      showPopupCancelAll: false,
      showOrderDloCancel: false,
      tempItem: {},
      feeDLO: 0,
      DLOid: null,

      fields: [
        {
          key: "orderNo",
          label: "Mã đơn hàng",
          thStyle: { width: "3%", "min-width": "140px" },
          show: true,
        },
        {
          key: "targetMethod",
          label: "Thiết bị",
          thStyle: { width: "3%" },
          show: false,
        },
        {
          key: "createdAt",
          label: "Ngày tạo đơn",
          thStyle: { width: "3%" },
          show: true,
        },
        {
          key: "processorStatus",
          label: "Trạng thái đơn",
          thStyle: { width: "3%", "min-width": "110px" },
          thClass: "text-center",
          tdClass: "text-center",
          show: true,
        },
        {
          key: "name",
          label: "Khách hàng",
          thStyle: { width: "3%" },
          show: true,
        },
        {
          key: "total",
          label: "Tổng tiền",
          thStyle: { width: "3%" },
          thClass: "text-right",
          tdClass: "text-right",
          show: true,
        },
        {
          key: "saleName",
          label: "Nhân viên bán hàng",
          thStyle: { width: "3%" },
          show: false,
        },
        // {
        //   key: "deliveryStatus",
        //   label: "Trạng thái giao hàng",
        //   thStyle: { width: "3%" },
        //   show: false,
        // },
        {
          key: "paymentStatus",
          label: "Trạng thái thanh toán",
          thStyle: { width: "3%" },
          show: true,
        },
        {
          key: "updatedAt",
          label: "Cập nhật lần cuối",
          thStyle: { width: "3%" },
          show: false,
        },
        {
          label: "",
          key: "edit",
          thStyle: { width: "2%" },
          thClass: "text-center",
          tdClass: "text-center",
          show: true,
        },
      ],

      // filter
      pickerOptions: this.getPickerOptions(),
      createdAtRange: "",
      updatedAtRange: "",
      saleChannel: "",
      optionsSaleChannel: [
        {
          text: "Tất cả",
          value: "",
        },
        {
          text: "NextShop Web",
          value: "NEXT_SHOP_POS_WEB_ENABLE_DRAFT",
        },
        // {
        //   text: "Gian hàng trực tuyến",
        //   value: "SALE_ONLINE_STORE",
        // },
        {
          text: "NextShop App",
          value: "NEXT_SHOP_POS_APP",
        },
      ],
      targetMethodName: {
        NEXT_SHOP_POS_WEB_ENABLE_DRAFT: "NextShop Web",
        SALE_ONLINE_STORE: "NextShop Web",
        NEXT_SHOP_POS_APP: "NextShop App",
      },

      currentPage: 1,
      totalElements: 0,

      // search
      showFilter: false,
      textSearch: "",
      search: {
        queryString: "",
        sortType: "DESC",
        sortBy: "createdAt",
        pageSize: 10,
        pageNum: 1,
        textSearch: "",
      },
      searchTmp: [],
      status: "",

      statusOptions: [
        {
          text: "Tất cả",
          value: "",
        },
        {
          text: "Nháp",
          value: "DRAFT",
        },
        {
          text: "Hoàn thành",
          value: "SUCCESS",
        },
        {
          text: "Đã hủy",
          value: "CANCELED",
        },
        {
          text: "Đang tiến hành",
          value: "PROCESSING",
        },
      ],
      optionSelect: [{ id: 1, text: "Hủy Đơn", color: "danger" }],
      // excelStoge
      localStorageKeyFordownloadStorage: "downloadStorage_order",
      localStorageKeyFordownloadStorage2: "downloadStorage_order_2",
    };
  },
  async created() {
    await this.createQueryData();
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.setNewQuery()
      try {
        this.loading = true;
        await this.getParams();
        const response = await OrdersService.getListItemV2(this.search);
        this.dataItem = [];
        if (response.success) {
          if (response.data.data.length > 0) {
            const datas = [];
            response.data.data.map((e) => {
              const body = {
                total: e.lineItemFinalizing && e.lineItemFinalizing.finalAmount ? e.lineItemFinalizing.finalAmount : 0,
                name: e.partyB.displayName ? e.partyB.displayName : "",
              };
              // check delivery
              e.SO_ORDER_OPERATION = {}
              if(e.furtherInstructions) {
                const SO_ORDER_OPERATION = e.furtherInstructions.find(item => item && item.key === "SO_ORDER_OPERATION")
                if (SO_ORDER_OPERATION) {
                  e.SO_ORDER_OPERATION = SO_ORDER_OPERATION
                }
              }

              datas.push({...e, ...body});
            });

            this.dataItem = datas;
            // console.log("data", response.data.data);
            this.totalElements = response.data.totalElements;
          }
        }
        this.loading = false;
        this.$nextTick(() => {
          this.currentPage = +this.$route.query.page
        })
      } catch (error) {
        console.error(error);
        this.loading = false;
      }
    },

    async getParams() {
      this.searchTmp = [];
      this.searchTmp.push("{locationToCreate} == '''" + this.locationId + "'''");

      if (this.status != "") {
        if (this.status == "CANCELED") {
          this.searchTmp.push("({processorStatus} == '''TIMEOUT''' or {processorStatus} == '''CANCEL''')");
        }

        if (this.status == "DRAFT") {
          this.searchTmp.push("({processorStatus} == '''NEW''' or {processorStatus} == '''LISTING''')");
        }

        if (this.status == "SUCCESS") {
          this.searchTmp.push("{processorStatus} == '''COMPLETE'''");
        }
        if (this.status == "PROCESSING") {
          this.searchTmp.push("{processorStatus} == '''PROCESSING'''");
        }
      }

      if (this.saleChannel) {
        this.searchTmp.push(`({targetMethod} == '''${this.saleChannel}''')`);
      }

      // if (this.textSearch.trim() != "") {
      //   this.search.textSearch = this.textSearch
      // }

      if (this.updatedAtRange) {
        this.searchTmp.push("{updatedAt} >= #" + `${moment(this.updatedAtRange[0]).format("YYYY-MM-DD")}` + `T00:00:00.000Z# and {updatedAt} <= #` + `${moment(this.updatedAtRange[1]).format("YYYY-MM-DD")}` + "T23:59:59.000Z#");
      }

      if (this.createdAtRange) {
        this.searchTmp.push("{createdAt} >= #" + `${moment(this.createdAtRange[0]).format("YYYY-MM-DD")}` + `T00:00:00.000Z# and {createdAt} <= #` + `${moment(this.createdAtRange[1]).format("YYYY-MM-DD")}` + "T23:59:59.000Z#");
      }

      if (this.searchTmp.length) {
        this.search.queryString = this.searchTmp.join(" and ") + " and {orderType} == '''SO'''";
      }
    },
    searchItem() {
      // console.log("seẢCH");
      this.showFilter = false;
      this.search.pageNum = 1;
      this.currentPage = 1;
      this.fetchData();
    },
    resetFilter() {
      this.currentPage = 1;
      this.search = {
        queryString: "",
        sort: "DESC",
        sortBy: "id",
        pageSize: 10,
        pageNum: 1,
      };
      this.createdAtRange = "";
      this.updatedAtRange = "";
      this.saleChannel = "";
      this.status = "";

      this.fetchData();
    },
    clickRowItem(item, index) {
      console.log(item, index);
      this.$router.push(`/pos/pos-detail/${item.id}`);
    },
    async chooseOption(event, item) {
      console.log({ event, item });
      // return
      if (event == "Hủy Đơn") {
        // this.confirmDeleteItem(item.id)
        this.tempItem = {};
        this.tempItem = item;

        if (item.orderStatus != "SUCCESS") {
          //check SO có DLO && SO chưa hoàn thành
          const deliveryData = this.tempItem.furtherInstructions.find(item => item && item.key == "SO_ORDER_OPERATION")
          if (deliveryData && deliveryData.params && deliveryData.params.deliveryStatus && deliveryData.params.deliveryStatus != null) {
            console.log('đơn có DLO');
            const deliveryHistory = JSON.parse(deliveryData.params.deliveryHistory)
            this.DLOid = deliveryHistory.at(-1).deliveryOrderId
            if(deliveryData.params.deliveryStatus == "NEW") {
              console.log('đơn chưa giao hàng');
              this.showOrderDloCancel = true
            } else if(deliveryData.params.deliveryStatus == "PROCESSING") {
              console.log('đơn đang giao hàng');
              this.showPopupCancelAll = true

            } else {
              console.log('không thể hủy đơn hàng');
              Swal.fire({
                title: "Thông báo",
                text: `Đơn hàng đã được giao hàng hoặc giao hàng thất bại nên không thể hủy.`,
                icon: "warning",
                confirmButtonText: "Xác nhận",
              });
            }
            return
          }
          
          // hủy đơn thường
          this.showOrderCancel = true;


        } else {
          // hủy đơn hoàn thành
          this.showOrderSuccessCancel = true;
        } 

      }
    },
    checkisSOFromReturn(order) {
      let SO = null
      if(order.orderStatus == "DRAFT") {
        SO = order.furtherInstructions.find(e => (e && e.params && e.params.sourceAction && e.params.sourceAction == "RETURN"))
      }
      if(SO) return true
      else return false
    },
    checkIsReturnAble(order) {
      const lineItem = order.lineItem
      let isReturnAble = false;
      for (let i = 0; i < lineItem.length; i++) {
        const item = lineItem[i];
        const returnable = item.lineItemOtherInfo.returnable ? +item.lineItemOtherInfo.returnable : null;
        if (returnable === null || returnable > 0) {
          return true;
        }
      }
      return isReturnAble
    },
    checkIsDeleteAble(order) {
      if(this.checkisSOFromReturn(order) || !this.checkIsReturnAble(order)) return false
      else return true
    },
    async confirmDeleteItem() {
      // console.log(this.tempItem);
      // return
      if(this.checkisSOFromReturn(this.tempItem)) {
        Swal.fire({
          title: "Thông báo!",
          text: `Không thể hủy do đơn hàng đang trong quá trình đổi hàng.`,
          icon: "warning",
          confirmButtonText: "Xác nhận",
        });
        return
      }

      if(!this.checkIsReturnAble(this.tempItem)) {
        Swal.fire({
          title: "Thông báo!",
          text: `Đơn hàng không còn sản phẩm nào để hủy.`,
          icon: "warning",
          confirmButtonText: "Xác nhận",
        });
        return
      }

      // console.log("hủy")
      // return
      const id = this.tempItem.id;
      const text = "";

      if (id != "") {
        const params = { id };
        try {
          this.loading = true;
          let responseOutcomeItem;
          // console.log(333, this.tempItem);
          // return
          if (this.tempItem.targetMethod !== "SALE_ONLINE_STORE") {
            // console.log(this.tempItem);
            

            // đơn thường
            console.log('đơn thường');
            // return
            const _paramsCancel = {
              id: params.id,
              reason: text,
            };
            responseOutcomeItem = await OrdersService.cancelItem(_paramsCancel);
          } else {
            // đơn từ gian hàng trực tuyến
            console.log('đơn từ gian hàng trực tuyến');
            if(!this.checkIsExport(this.tempItem) && !this.checkIsPayed(this.tempItem)) {
              // console.log("huy")
              const _paramsCancel = {
                orderId: id,
              };
              responseOutcomeItem = await OrdersService.cancelItemStore(_paramsCancel);
            } else {
              Swal.fire({
                title: "Thông báo",
                text: `Đơn hàng đã được thanh toán hoặc xuất kho nên không thể hủy.`,
                icon: "warning",
                confirmButtonText: "Xác nhận",
              });
            }

          }
          if (responseOutcomeItem && responseOutcomeItem.status === 200) {
            // huy don hang router
            Swal.fire({
              title: "Thành công",
              text: `Hủy đơn hàng thành công!`,
              icon: "success",
              confirmButtonText: "Xác nhận",
            });
            this.closePopup()
            await this.fetchData();
          }
        } catch (error) {
          console.error(error);
          Swal.fire({
            title: "Lỗi",
            text: `Hủy đơn hàng thất bại!`,
            icon: "error",
            confirmButtonText: "Xác nhận",
          });
        } finally {
          this.loading = false;
        }
      }
      return false;
    },
    closePopup() {
      this.showOrderCancel = false;
      this.showOrderSuccessCancel = false;
      this.showOrderDloCancel = false;
      this.showPopupCancelAll = false;
    },
    checkIsPayed(item) {
      let payInfor = item.outcomes.find((e) => e.cat === "NSH_PAYMENT");
      return payInfor && payInfor.params && payInfor.params.status && payInfor.params.status === "SUCCESS" ? true : false
      
    },
    checkIsExport(item) {
      const exportInfor = item.outcomes.find((e) => e.cat === "NSH_CHECKOUT");
      return exportInfor && exportInfor.params ? true : false
    },

    createQueryData() {
    const page = +this.$route.query.page
    const saleChannel = this.$route.query.saleChannel
    const status = this.$route.query.status
    const createdAtRange = this.$route.query.createdAtRange
    const updatedAtRange = this.$route.query.updatedAtRange
    
    this.currentPage = page ? page : 1
    this.search.pageNum = page ? page : 1
    this.saleChannel = saleChannel ? saleChannel : ""
    this.status = status ? status : ""
    this.createdAtRange = createdAtRange ? createdAtRange : ""
    this.updatedAtRange = updatedAtRange ? updatedAtRange : ""
    },
    changeCurrentPage(page) {
      this.currentPage = page
      this.search.pageNum = page;
      this.fetchData();
    },
    setNewQuery() {
      const query = Object.assign({}, this.$route.query);
      query.page = this.currentPage+"";
      query.saleChannel = this.saleChannel;
      query.status = this.status;
      query.createdAtRange = this.createdAtRange;
      query.updatedAtRange = this.updatedAtRange;
      // console.log(3333, _.isEqual(this.$route.query, query), this.$route.query, query);
      if(_.isEqual(this.$route.query, query)) return
      this.$router.replace({ query });
    },

    getPaymentsStatus(status) {
      switch (status) {
        case "UNPAID":
          return {
            status: "NEW",
            text: "Chưa thanh toán"
          }

        case "PAYING":
          return {
            status: "PROCESSING",
            text: "Chờ thanh toán"
          }
        case "PAID_IN_FULL":
          return {
            status: "COMPLETE",
            text: "Đã thanh toán"
          }
      
        default:
          return {
            status: status,
            text: ""
          }
      }
    },
    // getDeliveryStatus,

    // DLO
    getDloId(orderData) {
      const deliveryData = orderData.furtherInstructions.find(item => item.key == "SO_ORDER_OPERATION")
      const deliveryHistory = JSON.parse(deliveryData.params.deliveryHistory)
      return deliveryHistory && deliveryHistory.length ? deliveryHistory.at(-1).deliveryOrderId : null
    },

    async handleOrderDLOCancelAndDoNothing(DLOid) {
      this.loading = true
      // const params = {
      //   "nshOrderId": DLOid,   // id đơn DLO
      //   "partnerType": "OUTSIDE_SHIPPER_TYPE",      // OUTSIDE_SHIPPER_TYPE nếu là ship ngoài
      //   "reason": ""
      // }
      const params = {
        orderId: DLOid,
        reason: "",
      }
      // this.showSwalSuccess("Hủy đơn hàng")
      // console.log(params)
      // return
      try {
        const res = await OrdersService.cancelBeforeConfirm(params)
        if(res.success) {
          this.closePopup()
          await this.fetchData()
          this.showSwalSuccess("Hủy đơn hàng")
        } else {
          this.showSwalError("Hủy giao hàng", res.message)
        }
      } catch (error) {
        console.log(error)
        this.showSwalError("Hủy giao hàng")
      } finally {
        this.loading = false
      }
    },
    async confirmCancelAll() {
      const params = {
        "orderId" : this.getDloId(this.tempItem),
        "newStatus": "FAILED",   // trạng thái mới:  COMPLETE hoặc FAILED
        "isCancelSO": true,  // nếu cập nhập DLO FAILED và muốn hủy luôn so -> truyền true
        "returnFee" : this.feeDLO*1000
      }
      this.loading = true
      // console.log(params);
      // return
      try {
        const res = await OrdersService.updateStatusByMerchant(params)
        if(res.success) {
          this.showPopupCancelAll = false
          this.fetchData()
          this.showSwalSuccess("Hủy đơn hàng")
        } else {
          this.showSwalError("Hủy đơn hàng", res.message)
        }
      } catch (error) {
        console.log(error)
        this.showSwalError("Hủy đơn hàng")
      } finally {
        this.loading = false
      }
    },
    // xuat excel
    async clickExportData() {
      try {
        this.isLoadLinkDownload = true
        const params = {
          "isOnlyReturnable": false,
          "lastIndex": "",
          "queryString": this.search.queryString,
          "limit": 50000,
          "textSearch": this.search.textSearch,
        }
        const response = await OrdersService.exportData(params)
        console.log("data:::", response);
        if(response.success){
          this.clickExportDataMixin(response.data, '/nsh/iex/api/order/download-file/')
        } else {
          this.$message.warning('Máy chủ đang bận. Hãy thử lại sau. ')
        }
      } catch (error) {
        this.$message.warning('Máy chủ đang bận. Hãy thử lại sau. '+ error)
      }
    },
    // export excel chi tiet don
    async clickExportData2() {
      try {
        this.isLoadLinkDownload2 = true
        const params = {
          "isOnlyReturnable": false,
          "lastIndex": "",
          "queryString": this.search.queryString,
          "limit": 50000,
          "textSearch": this.search.textSearch,
        }
        const response = await OrdersService.exportDataLineItems(params)
        console.log("data:::", response);
        if(response.success){
          this.clickExportDataMixin2(response.data, '/nsh/iex/api/order/download-file/')
        } else {
          this.$message.warning('Máy chủ đang bận. Hãy thử lại sau. ')
        }
      } catch (error) {
        this.$message.warning('Máy chủ đang bận. Hãy thử lại sau. '+ error)
      }
    },
 
  },
  watch: {
    "search.textSearch": _.debounce(function() {
      if (this.search.textSearch == "") this.searchItem();
    },700),
  },
};
</script>

<style lang="scss">
.order-list {
  .pagination {
    margin: 0;
  }
  .fix-button {
    height: 44px;
    .el-input__inner {
      height: 44px;
    }
  }
  .title-header-77 {
    color: #23313e;
    font-size: 20px;
    font-weight: bold;
  }
  .order-list-nav {
    padding: 0px 0px 24px 0;
  }
  tr {
    height: 68px;
  }
  .el-button-absolute{
    position: absolute!important;
    right: 1.2%!important;
    background: #d7d8da!important;
  }
}
</style>
